<template>
  <div>
    <ui-stage>
      <div class="mb">
        <ui-alert type="success" :closable="false" class="mb">
          <h3>请选择日期 <small style="color: red">*</small></h3>
          <ui-datetime-picker v-model="date" type="date" class="mb" />
        </ui-alert>

        <div v-if="sections && sections.length > 0" class="mb">
          <el-tabs v-model="currentSection" @tab-click="handleTabClick">
            <el-tab-pane
              v-for="sectionItem in sections"
              :key="sectionItem"
              :label="sectionItem"
              :name="`SECTION_${sectionItem}`"
            />
            <el-tab-pane name="预览">
              <span slot="label"> <i class="el-icon-view"></i> 预览 </span>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div>
          <h3>今日是否施工</h3>
          <div>
            <ui-data-select
              :options="optionsShouldWork"
              v-model="shouldWork"
              :readonly="!effectiveCanEdit"
            />
          </div>
        </div>

        <div>
          <h3>交底内容：<small>每日施工部位及注意事项</small></h3>
          <ui-input
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 20 }"
            v-model="notice"
            :readonly="!effectiveCanEdit"
          ></ui-input>
        </div>

        <div>
          <h3>今日作业内容：</h3>
          <ui-input
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 20 }"
            v-model="workContent"
            :readonly="!effectiveCanEdit"
          ></ui-input>
        </div>

        <div v-if="isChildProject">
          <el-row :gutter="10">
            <el-col :span="8">
              <h3>现场照片</h3>
              <ui-uploads v-model="form.photos" :readonly="!canEdit"></ui-uploads>
            </el-col>
            <el-col :span="8">
              <h3>人员照片</h3>
              <ui-uploads v-model="form.workersPhoto" :readonly="!canEdit"></ui-uploads>
            </el-col>
            <el-col :span="8">
              <h3>人员数</h3>
              <ui-data-select v-model="form.workersCount" :options="workersCountPicker" />
            </el-col>
          </el-row>
          <div class="mt" v-if="pickers.selectedOpsZonesIds">
            <UiTransferList
              v-model="form.selectedOpsZonesIds"
              title="施工部位"
              :options="pickers.selectedOpsZonesIds.options"
              :readonly="!effectiveCanEdit"
            />
          </div>
        </div>

        <div class="mt" v-if="pickers.selected_danger_zone_ids">
          <UiTransferList
            v-model="form.selected_danger_zone_ids"
            :options="pickers.selected_danger_zone_ids.options"
            title="危险源"
            :readonly="!effectiveCanEdit"
          />
        </div>

        <ui-flex row center style="margin-top: 20px" v-if="effectiveCanEdit">
          <ui-button type="primary" @click="handleSubmit" round style="width: 120px"
            >保存
          </ui-button>
        </ui-flex>
      </div>
    </ui-stage>
  </div>
</template>

<script>
import { formatDateTime, _, UiAdminForm } from '@yishitec/web';
import { adminList } from '@yishitec/web/mixins';
import UiTransferList from '../../../components/UiTransferList.vue';
import permissions from '../../../mixins/permissions';
import withConfirm from '../../../mixins/withConfirm';

export default {
  name: 'EditDailyDangerZones',
  components: { UiTransferList },
  mixins: [adminList, permissions, withConfirm],
  data() {
    const date = formatDateTime(undefined, 'YYYY-MM-DD');
    return {
      projectId: _.get(this.$route, 'params.vId'),
      date,
      collapseDangerZones: ['selected'],
      selectedIds: [],
      dangerZones: [],
      notice: '',
      workContent: '',
      canEdit: false,
      shouldWork: '是',
      optionsShouldWork: ['是', '否'],
      attributes: [],
      pickers: {},
      form: {},
      isChildProject: false,
      workersCountPicker: [],
      sections: [],
      currentSection: '',
      effectiveCurrentSection: '',
      originalFormData: null,
    };
  },
  watch: {
    date(next, prev) {
      this.fetchDangerZones();
      this.fetchData();
    },
  },
  computed: {
    isFormDirty() {
      if (!this.originalFormData || this.isPreviewMode) {
        return false;
      }
      return (
        this.notice !== this.originalFormData.notice ||
        this.workContent !== this.originalFormData.workContent ||
        this.shouldWork !== this.originalFormData.shouldWork ||
        JSON.stringify(this.form.selected_danger_zone_ids || []) !==
          JSON.stringify(this.originalFormData.selected_danger_zone_ids || []) ||
        JSON.stringify(this.form.selectedOpsZonesIds || []) !==
          JSON.stringify(this.originalFormData.selectedOpsZonesIds || []) ||
        JSON.stringify(this.form.photos || []) !==
          JSON.stringify(this.originalFormData.photos || []) ||
        JSON.stringify(this.form.workersPhoto || []) !==
          JSON.stringify(this.originalFormData.workersPhoto || []) ||
        this.form.workersCount !== this.originalFormData.workersCount
      );
    },
    isPreviewMode() {
      return this.effectiveCurrentSection === '预览';
    },
    currentSectionName() {
      if (this.isPreviewMode) {
        return null;
      }
      if (this.effectiveCurrentSection && this.effectiveCurrentSection.startsWith('SECTION_')) {
        return this.effectiveCurrentSection.replace(/^SECTION_/, '');
      }
      return this.effectiveCurrentSection;
    },
    effectiveCanEdit() {
      return this.canEdit && !this.isPreviewMode;
    },
  },
  mounted() {
    this.fetchDangerZones();
    this.fetchData();
  },
  filters: {
    filterDate(value) {
      return formatDateTime(value, 'YYYY-MM-DD');
    },
  },
  methods: {
    async fetchData() {
      // Use /date API for preview mode, /date-sectioned for section editing
      const apiEndpoint = this.isPreviewMode
        ? '/api/daily-danger-zones/date'
        : '/api/daily-danger-zones/date-sectioned';

      const requestBody = this.isPreviewMode
        ? {
            date: this.date,
            projectId: this.projectId,
            mode: 'view',
          }
        : {
            date: this.date,
            projectId: this.projectId,
            section: this.currentSectionName,
          };

      const res = await this.withLoading(this.api(apiEndpoint, requestBody));
      const { attributes, pickers, canEdit, isChildProject, sections, ...form } = res || {};
      this.attributes = attributes;
      this.pickers = pickers || [];
      this.canEdit = canEdit;
      this.form = form;
      this.isChildProject = isChildProject;
      this.workersCountPicker = _.map(_.get(this.pickers.workersCount, 'options'), (i) => ({
        title: i.title,
        value: i.key,
      }));

      // Set sections and current section
      if (sections && sections.length > 0) {
        this.sections = sections;
      }
      // Only auto-select first section if not in preview mode and effectiveCurrentSection is not set or invalid
      if (!this.isPreviewMode && this.sections && this.sections.length > 0) {
        const isCurrentSectionValid =
          this.effectiveCurrentSection &&
          (this.effectiveCurrentSection.startsWith('SECTION_') ||
            this.sections.includes(this.effectiveCurrentSection.replace(/^SECTION_/, '')));
        if (
          !this.effectiveCurrentSection ||
          (!isCurrentSectionValid && this.effectiveCurrentSection !== '预览')
        ) {
          const [firstSection] = this.sections;
          this.effectiveCurrentSection = `SECTION_${firstSection}`;
          this.currentSection = `SECTION_${firstSection}`;
        }
      }

      const notice = res;
      this.notice = notice.notice || '';
      this.workContent = notice.workContent || '';
      this.selectedIds = JSON.parse(notice.selected_danger_zone_ids || '[]');
      this.shouldWork = notice.shouldWork || '是';
      this.canEdit = notice.canEdit;

      // Store original form data for dirty checking (only for section editing, not preview)
      if (!this.isPreviewMode) {
        this.originalFormData = {
          notice: this.notice,
          workContent: this.workContent,
          shouldWork: this.shouldWork,
          selected_danger_zone_ids: JSON.parse(
            JSON.stringify(this.form.selected_danger_zone_ids || []),
          ),
          selectedOpsZonesIds: JSON.parse(JSON.stringify(this.form.selectedOpsZonesIds || [])),
          photos: JSON.parse(JSON.stringify(this.form.photos || [])),
          workersPhoto: JSON.parse(JSON.stringify(this.form.workersPhoto || [])),
          workersCount: this.form.workersCount,
        };
      }
    },
    async handleTabClick(tab) {
      const newSection = tab.name;
      const previousSection = this.effectiveCurrentSection;

      if (newSection === previousSection) {
        return;
      }

      // Don't check dirty state when switching to/from preview mode (preview is readonly)
      if (newSection !== '预览' && previousSection !== '预览' && this.isFormDirty) {
        try {
          await this.$confirm('有未提交的修改，是否继续编辑？', '提示', {
            confirmButtonText: '留在当前页面',
            cancelButtonText: '放弃未保存的修改',
            type: 'warning',
          });
          this.$nextTick(() => {
            this.currentSection = previousSection;
          });
          return;
        } catch (e) {
          // User cancelled, continue to switch tab
        }
      }
      this.effectiveCurrentSection = newSection;
      await this.fetchData();
    },
    async fetchDangerZones() {
      const dangerZones = await this.withLoading(
        this.api('/api/danger-zones/list', {
          currentProjects: _.intersection(this.currentProjects, [Number(this.projectId)]),
          filter: '',
        }),
      );

      this.dangerZones = _.map(
        _.sortBy(dangerZones.list, [(item) => item.level !== '危大危险源']),
        (item) => ({
          id: item.id,
          title: [
            item.level === '危大危险源' ? '【危大】' : '',
            item.title,
            item.sn,
            item.location,
            item.op_status,
          ].join(' '),
        }),
      );
    },
    async handleSubmit() {
      if (this.isPreviewMode) {
        this.$message({
          type: 'warning',
          message: '预览模式下不能保存',
        });
        return;
      }

      const resSaveNotice = await this.withLoading(
        this.api('/api/daily-danger-zones/save-date-fraction', {
          projectId: this.projectId,
          date: this.date,
          section: this.currentSectionName,
          notice: this.notice,
          workContent: this.workContent,
          dangerZoneIds: this.form.selected_danger_zone_ids,
          shouldWork: this.shouldWork,
          photos: this.form.photos,
          workersPhoto: this.form.workersPhoto,
          workersCount: this.form.workersCount,
          selectedOpsZonesIds: this.form.selectedOpsZonesIds,
        }),
      );

      if (!resSaveNotice) return;

      this.$message({
        type: 'success',
        message: '已保存',
      });

      // Update original form data to reset dirty state
      this.originalFormData = {
        notice: this.notice,
        workContent: this.workContent,
        shouldWork: this.shouldWork,
        selected_danger_zone_ids: JSON.parse(
          JSON.stringify(this.form.selected_danger_zone_ids || []),
        ),
        selectedOpsZonesIds: JSON.parse(JSON.stringify(this.form.selectedOpsZonesIds || [])),
        photos: JSON.parse(JSON.stringify(this.form.photos || [])),
        workersPhoto: JSON.parse(JSON.stringify(this.form.workersPhoto || [])),
        workersCount: this.form.workersCount,
      };
    },
  },
};
</script>
